const emptyFunction = () => {
};
export default class HttpRequestSetting {
    constructor() {
        this.defaultPostProgressMessage = null;
        this.defaultDeleteProgressMessage = null;
        this.responseNotModifiedActionFunction = emptyFunction;
        this.responseUnAuthorizedActionFunction = emptyFunction;
        this.responseForbiddenActionFunction = emptyFunction;
        this.responseServiceUnavailableActionFunction = emptyFunction;
    }
    executeSuccessMessage(message, jsonResponse, option) {
        // console.log({option});
        if (message == null) {
            return;
        }
        if (this.successMessageAction == null) {
            return;
        }
        this.successMessageAction(message, jsonResponse, option);
    }
    executeProgressMessage(message) {
        if (message == null) {
            return;
        }
        if (this.progressMessageAction == null) {
            return;
        }
        this.progressMessageAction(message);
    }
    executeErrorMessage(message, jsonResponse) {
        if (message == null) {
            return;
        }
        if (this.errorMessageAction == null) {
            return;
        }
        let description = null;
        if ('description' in jsonResponse) {
            description = jsonResponse['description'];
        }
        this.errorMessageAction(message, description, jsonResponse);
    }
    executeFinishProgressMessage() {
        if (this.finishProgressMessageAction == null) {
            return;
        }
        this.finishProgressMessageAction();
    }
}
